/**
 * Custom popup
 * 
 * @Author: Focci
 * @Date: 2023-07-12 17:06:59
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-12 17:06:59
 */

import PropTypes from 'prop-types'
import { useCallback, useEffect, useState } from 'react'
import { Popup } from 'react-map-gl'
import './custom-popup.css'

export default function CustomPopup({
  /**
   * { lng, lat }
   * 这里不直接传经纬度是因为相同的 lng, lat 不会触发useEffect更新
   * 比如 popup 关闭了，就不能再次打开，
   * 如果传入一个新的 data 对象, 就会触发useEffect更新
   */
  data = {},
  popupProps = null,
  onClose = () => {},
  children
}) {
  const [show, setShow] = useState(false)

  const handleClose = useCallback(() => {
    setShow(false)
    onClose()
  }, [onClose])

  useEffect(() => {
    const timer = setTimeout(() => data && setShow(true))
    return () => clearTimeout(timer)
  }, [data])

  if(!(show && data)) {
    return null
  }
  
  return (
    <Popup
      longitude={data.lng} 
      latitude={data.lat}
      onClose={handleClose}
      maxWidth="40rem"
      offset={8}
      className="custom-popup-wrapper"
      style={{ zIndex: 8 }}
      {...popupProps}
    >
      {children}
    </Popup>
  )
}

CustomPopup.propTypes = {
  data: PropTypes.object.isRequired,
  popupProps: PropTypes.object,
}
